import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import appConfig from './plugins/appconfig'
import axios from './plugins/axios.js'
import routePermission from './directives/routePermission'
import roleBasedRouterLinkMixin from './mixins/roleBasedRouterLink'

// Import global components
import PermissionRouterLink from './components/PermissionRouterLink.vue'
import PermissionGuard from './components/PermissionGuard.vue'
import RoutePermissionGuard from './components/RoutePermissionGuard.vue'

// Import global styles
import './styles/tailwind.css'
import './assets/scss/main.scss'
import './components/style/PermissionStyles.css'

// Import icons
import './styles/icons.css';

// Create and mount the Vue application
const app = createApp(App)

// Register global properties
app.config.globalProperties.$appName = process.env.VUE_APP_TITLE || 'CACFP FOOD PROGRAM'
app.config.globalProperties.$axios = axios
app.provide('axios', axios)
app.use(appConfig)

// Configure error handling
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err)
  console.error('Vue Error Info:', info)
}

// Apply global mixin for role-based router-link visibility
app.mixin(roleBasedRouterLinkMixin)

// Install router and store
app.use(store)
app.use(router)

// Register global components
app.component('PermissionRouterLink', PermissionRouterLink)
app.component('PermissionGuard', PermissionGuard)
app.component('RoutePermissionGuard', RoutePermissionGuard)

// Register global directives
app.directive('route-permission', routePermission)

// Mount the application
app.mount('#app')
